<template>
  <div class="account-login-box">
    <div class="form-box">
      <el-form ref="form" :model="dataModel" label-width="0" :rules="rules">
        <el-form-item label="" prop="mobile_phone" :required="false">
          <el-input v-model.trim="dataModel.mobile_phone" :maxlength="11" autofocus @keyup.enter.native="formSubmit" placeholder="输入手机号"></el-input>
        </el-form-item>

        <el-form-item label="" prop="code">
          <el-row :gutter="12">
            <el-col :span="15">
              <el-input v-model.trim="dataModel.code" :maxlength="4" @keyup.enter.native="formSubmit" placeholder="输入短信中的验证码"></el-input>
            </el-col>
            <el-col :span="9">
              <el-button :disabled="!phoneIsPass || verifyCodeInfo.time > 0" class="send-code-btn" :class="{small: verifyCodeInfo.time > 0}" @click="sendVerifyCode">
                {{verifyCodeInfo.time > 0 ? `重新获取(${verifyCodeInfo.time}s)` : '获取验证码'}}
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="" prop="sliderVerify">
          <slider-verify v-model="sliderVerify"></slider-verify>
        </el-form-item>
        <div class="login-addon">
          <div class="account-login" @click="gotoAccountLogin">账号密码登录</div>
        </div>
        <el-button class="login-btn" type="primary" @click="formSubmit">登录</el-button>
      </el-form>
    </div>
    <div class="wx-login-box" @click="gotoWxLogin">
      <img class="wx-icon" src="https://o.666visa.cn/static/ssqwxa/register/wx-icon.png" />
      <div class="wx-label">微信登录</div>
    </div>
  </div>
</template>

<script>
import Http from '../../../../libs/http';
import SliderVerify from './slider-verify';

export default {
  name: 'wx-qrcode-login',
  components: {
    SliderVerify,
  },
  data() {
    return {
      dataModel: {
        mobile_phone: '',
        code: '',
      },
      sliderVerify: false,
      rules: {
        mobile_phone: [
          { required: true, trigger: 'blur', message: '请输入手机号' },
          { pattern: /^1\d{10}$/, trigger: 'blur', message: '请输入正确手机号' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{4}$/, trigger: 'blur', message: '请输入正确的验证码' },
        ],
      },
      verifyCodeInfo: {
        time: 0,
      },
    };
  },
  computed: {
    phoneIsPass() {
      if (this.dataModel.mobile_phone) {
        return /^1\d{10}$/.test(this.dataModel.mobile_phone);
      }
      return false;
    },
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    formSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.sliderVerify) {
            this.$message.error('请滑动滑块');
            return;
          }
          const postData = {
            mobile_phone: this.dataModel.mobile_phone,
            code: this.dataModel.code,
            login_type: 2,
          };
          Http.post('/sys/peer_login', postData).then((data) => {
            this.$emit('login-success', data);
          }).catch((e) => {
            if (e) console.log(e);
          });
        }
      });
    },
    sendVerifyCode() {
      Http.post('/sys/sys_verify_code_get', {
        mobile_phone: this.dataModel.mobile_phone,
        action: 0,
      }).then(() => {
        this.verifyCodeInfo.time = 60;
        this.timer = setInterval(() => {
          this.verifyCodeInfo.time -= 1;
          if (this.verifyCodeInfo.time <= 0) {
            clearInterval(this.timer);
          }
        }, 1000);
      });
    },
    gotoAccountLogin() {
      this.$emit('change-page', 2);
    },
    gotoWxLogin() {
      this.$emit('change-page', 1);
    },
  },
};
</script>
<style lang="less" scoped>

.account-login-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #2F333D;
  font-size: 14px;
  line-height: 1;
  .form-box{
    width: 100%;
    height: 295px;
    /deep/ .el-form-item{
      margin-bottom: 20px;
      .el-input__inner{
        height: 48px;
        color: #2F333D;
        font-size: 16px;
        border-radius:2px;
      }
    }
    .login-addon{
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      margin-bottom: 16px;
      .account-login{
        color: #599FFF;
        cursor: pointer;
      }
    }
    .send-code-btn{
      width: 100%;
      height: 48px;
      font-size: 16px;
      border-radius:2px;
      border:1px solid #599FFF;
      color: #599FFF;
      &:disabled{
        border: 1px solid #E9EEF2;
        color: #91999F;
        background:rgba(250,251,252,1);
      }
      &.small{
        font-size: 14px;
      }
    }
    .login-btn{
      width: 100%;
      height: 48px;
      font-size: 16px;
      background: #599FFF;
      border-radius:2px;
      &:hover{
        opacity: 0.8;
      }
    }
  }
  .wx-login-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    .wx-icon{
      width: 48px;
      height: 48px;
    }
    .wx-label{
      margin-top: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/login/components/phone-login.vue